import {hostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const getDashboardStats = async () => {
  try {
    const result = await fetch(`${hostName}/business/dashboard-stats`, {
      method: "GET",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });

    // Handle session expiration
    if (result.status === 401 || result.status === 403) {
      console.warn("Session expired, redirecting to login");
      localStorage.removeItem("access_token");
      localStorage.removeItem("expiresIn");
      localStorage.removeItem("currentUser");
      window.location.href = "/login";
      return {
        hasSuccess: false,
        data: null,
      };
    }

    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
